class HomeController {
  /* @ngInject */
  constructor (Auth, $http, $state, user, $location, $rootScope, $mdToast, $scope, $mdDialog, $anchorScroll, $sce, $window) {
    this.$http = $http
    this.$rootScope = $rootScope
    this.Auth = Auth
    this.$mdDialog = $mdDialog
    this.$mdToast = $mdToast
    this.$scope = $scope
    this.$anchorScroll = $anchorScroll
    this.$sce = $sce
    this.user = user
    this.jobs = {}
    this.$window = $window
    this.job
    this.dates
    this.map = {
      center: {
        latitude: 37.7749,
        longitude: -122.4194
      },
      options: {
        scrollwheel: false
      }
    }
    this.getFeatureFlags()

    this.Auth.getDetails().then(details => {
      if (details.highest_cm_app_version.split('.')[0] >= 7 && details.isWorker) {
        document.location.href = CONFIG.CM7_WEB_URL
      }
    })
  }

  getFeatureFlags () {
    this.Auth.splitClient.ready().then(() => {
      let attributes = { region_id: this.user.region_id }
      const treatment = this.Auth.splitClient.getTreatment('use_remote_interviews', attributes)
      if (treatment === 'on' && (this.user.status === 'STARTED_SIGN_UP' || this.user.status === 'FOLLOW_UP_INTERVIEW' || this.user.status === 'NO_SHOW_INTERVIEW')) {
        this.interviewUrl = `https://bluecrewjobs.com/schedule-interview?region=${this.user.region_id}&email=${this.user.username}&name=${this.user.firstName}%20${this.user.lastName}&phone=${this.user.phone}&id=${this.user.id}`
        this.remoteInterview = false
        this.calendly = false
      } else if (treatment === 'vidcruiter' && (this.user.status === 'STARTED_SIGN_UP' || this.user.status === 'FOLLOW_UP_INTERVIEW' || this.user.status === 'NO_SHOW_INTERVIEW')) {
        this.interviewUrl = 'https://bluecrewjobs.hiringplatform.com/38010-bluecrew-interview/137288-audio-interview/en'
        this.remoteInterview = false
        this.calendly = false
      }
    }).catch(() => {
      console.log('Error Initializing Split.io')
    })
  }

  close () {
    this.$mdDialog.cancel()
  }

  showInterviews () {
    const parentEl = document.body
    this.$mdDialog.show({
      contentElement: '#showInterviews',
      parent: parentEl,
      clickOutsideToClose: true,
      fullscreen: true
    })
  }

  showInterviewsNewTab () {
    this.$window.open(
      this.interviewUrl
    )
  }

  getTrustResource (url) {
    return this.$sce.trustAsResourceUrl(url)
  }

  acceptJob () {
    const ctrl = this
    this.$http({
      url: api.getBase() + '/job/' + ctrl.job.jobId + '/accept', // eslint-disable-line
      method: 'GET'})
    .then(response => {
      if (response.data === 'OVERLAP') {
        ctrl.$mdToast.showSimple('Sorry, this job overlaps with another job!')
        return
      }

      if (response.data !== 'SUCCESS') {
        ctrl.$mdToast.showSimple('Oops, something went wrong...')
        return
      }

      // SUCCESS
      ctrl.$mdToast.showSimple('You accepted a job.')
      ctrl.$mdDialog.cancel()
      const jobId = ctrl.job.jobId
      let jobs = ctrl.jobs

      // move all shifts for this job from recommendedJobs to scheduledJobs
      for (let date in jobs) {
        const dateShifts = jobs[date]
        dateShifts.map((job, index) => {
          if (job.jobId === jobId) {
            job.isRecommended = false
            job.isScheduled = true
            job.jobType = 'scheduledJobs'
          }
        })
      }
    }, (response) => {
      ctrl.$mdToast.showSimple('Oops, something went wrong...')
    })
  }

  rejectJob (reason) {
    let ctrl = this

    this.$http({
      url: api.getBase() + '/user/cancelJob?jobId=' + ctrl.job.jobId + '&reason=' + reason, // eslint-disable-line
      method: 'GET'})
    .then(response => {
      ctrl.$mdToast.showSimple('The job has been cancelled.')

      ctrl.$mdDialog.cancel()

      let jobs = ctrl.jobs

      let jobType = 'recommendedJobs'

      if (this.job.isWaitlist) {
        jobType = 'waitlistJobs'
      }

      if (this.job.isScheduled) {
        jobType = 'scheduledJobs'
      }

      // remove all shifts for this job
      for (let date in jobs) {
        const dateShifts = jobs[date]
        dateShifts[jobType].map((job, index) => {
          if (job.jobId === ctrl.job.jobId) {
            jobs[date].splice(index, 1)
          }
        })
      }
    }, function (respopnse) {
      ctrl.$mdToast.showSimple('Oops, something went wrong...')
    })
  }
}

export default HomeController
